import { useSgwtTranslation } from '../../../../common/i18n/SgwtTranslationContext';
import './AnimatedIcon.scss';

type AIIconProps = {
  className?: string;
  small?: boolean;
};

export const AIAnimatedIcon = ({ className, small = false }: AIIconProps) => {
  const { translate } = useSgwtTranslation();

  if (small) {
    return (
      <div className="sgwt-chatbot-animation-container-small">
        <div className="olive olive-1" />
        <div className="olive olive-2" />
        <div className="olive olive-3" />
        <div className="olive olive-4" />
        <div className="olive olive-5" />
        <div className="olive olive-6" />
      </div>
    );
  }

  return (
    <div className={`flex-fill flex-column flex-center-x text-secondary ${className ?? ''}`}>
      <div className="sgwt-chatbot-animation-container">
        <div className="olive olive-1" />
        <div className="olive olive-2" />
        <div className="olive olive-3" />
        <div className="olive olive-4" />
        <div className="olive olive-5" />
        <div className="olive olive-6" />
      </div>
      <h4>{translate('ai.assistance')}</h4>
    </div>
  );
};

export const AIIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>AI Generated</title>
    <ellipse cx="11.8213" cy="20" rx="4.5" ry="1" fill="currentColor" />
    <ellipse cx="12.0002" cy="16.3179" rx="8.82144" ry="1.56072" fill="currentColor" />
    <ellipse cx="12.1211" cy="11.5" rx="10.5" ry="2.3" fill="currentColor" />
    <ellipse cx="12.0002" cy="6.68218" rx="8.82144" ry="1.56072" fill="currentColor" />
    <ellipse cx="11.8213" cy="3" rx="4.5" ry="1" fill="currentColor" />
  </svg>
);
